import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @public */ export const loadableIdValidator = idValidator("loadable");
/** @public */ export function createLoadableValidator(type, props, meta) {
    return T.object({
        id: loadableIdValidator,
        typeName: T.literal("loadable"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        status: T.union("status", {
            "not-loaded": T.object({
                status: T.literal("not-loaded")
            }),
            loading: T.object({
                status: T.literal("loading")
            }),
            refreshing: T.object({
                status: T.literal("refreshing")
            }),
            ready: T.object({
                status: T.literal("ready"),
                latestTimestamp: T.number
            }),
            failed: T.object({
                status: T.literal("failed"),
                retryable: T.boolean.optional(),
                message: T.string.optional()
            })
        })
    });
}
